<template>
  <AppCaseItemsDataTableBase :casesid="casesid" :item-type="serviceTypeID">
    <template slot="bottom" slot-scope="props">
      <AttachServicesToCaseButton :casesid="props.casesid" @resource-attached="props.loadListing"></AttachServicesToCaseButton>

      <AppEditItemCheckListDialog :item-id.sync="props.itemForCheckList.id" :item-type="serviceTypeID" :cases-id="casesid"></AppEditItemCheckListDialog>
    </template>
  </AppCaseItemsDataTableBase>
</template>

<script>
  import AttachServicesToCaseButton from '@/components/buttons/AttachServicesToCaseButton'
  import AppEditItemCheckListDialog from '@/components/dialogs/AppEditItemCheckListDialog.vue'
  import AppCaseItemsDataTableBase from '@/components/AppCaseItemsDataTableBase'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    components: { AttachServicesToCaseButton, AppEditItemCheckListDialog, AppCaseItemsDataTableBase },
    mixins: [ itemTypesMixins ],
    props: {
      casesid: {
        type: Number,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CaseServicesDataTable.vue?3ed0faa9